import { useFinanceSimulationSelector } from "@redux/reducers/deal";
import { getIsVACJourneySelected } from "@shared/v2/lib/getIsVACJourneySelected";

export const useIsVACJourneySelected = () => {
  const financeSimulation = useFinanceSimulationSelector();

  return getIsVACJourneySelected(financeSimulation.journey);
};
